import React from "react";
import { Helmet } from "react-helmet-async";
import { Palette, Code, Smartphone } from "lucide-react";
import "./style.css";
import Pricing from "../PricesSection";

const Services = () => {
    const services = [
        {
            icon: Palette,
            title: "Web Design",
            description: "Bringing your vision to life",
            theme: "nebula",
            details:
                "Creating beautiful, intuitive designs that captivate your audience and enhance user experience.",
        },
        {
            icon: Code,
            title: "Web Development",
            description: "Robust and scalable web applications",
            theme: "primary",
            details:
                "Building high-performance, secure web solutions using modern technologies and best practices.",
        },
        {
            icon: Smartphone,
            title: "App Development",
            description: "Native mobile apps for Android and iOS",
            theme: "aurora",
            details:
                "Crafting seamless mobile experiences that work flawlessly across all devices.",
            badge: "Coming Soon",
        },
    ];

    return (
        <section id="services" className="services-section">
            <Helmet>
                <title>Our Expertise | Moonface Techs</title>
                <meta name="description" content="Explore our comprehensive web design, web development, and app development solutions tailored for your business." />
            </Helmet>

            <div className="services-container">
                <p className="rule-mono">
                    Capability <span className="rule-line" />
                </p>

                <div className="services-header">
                    <h2 className="services-title">
                        Our <span className="text-nebula-gradient">Expertise</span>
                    </h2>
                    <p className="services-subtitle">
                        Comprehensive solutions to bring your digital vision to life
                    </p>
                </div>

                <div className="services-grid">
                    {services.map((service) => {
                        const IconComponent = service.icon;
                        return (
                            <article
                                key={service.title}
                                className={`service-card service-${service.theme}`}
                            >
                                <span className="service-accent-bar" />

                                <div className="service-card-top">
                                    <div className="service-icon-wrapper">
                                        <IconComponent className="service-icon" />
                                    </div>
                                    {service.badge && (
                                        <span className="service-badge">
                                            {service.badge}
                                        </span>
                                    )}
                                </div>

                                <h3 className="service-card-title">
                                    {service.title}
                                </h3>
                                <p className="service-card-desc">
                                    {service.description}
                                </p>
                                <p className="service-card-details">
                                    {service.details}
                                </p>
                            </article>
                        );
                    })}
                </div>
                {/* <Pricing /> */}
            </div>
            <Pricing />
        </section>
    );
};

export default Services;